const { AllSocialMedia, AllSubcategory, AllCategory, AllAboutUs, AllVision, AllOurVictory, AllServiceDescription, AllExceptional, AllHighlights, AllPhilosophy, AllExcellence, AllCorporatehospitality, AllBrandvalue, AllQualitypolicy, AllPrivacypolicy, AllTermscondition } = require("../features/admin/common/Slice");
const { default: privacypolicy } = require("../redux/contain");

exports.APIS = {
  Auth: "/common/auth/admin-login",
  ChangePassword: "/common/auth/change-password",


  Masters: {
    Country: "/admin/masters/country",
    State: "/admin/masters/state",
    category: "/admin/masters/categories",
    subcategory: "/admin/masters/subcategories",
    city: "/admin/masters/cities",
    pincode:"/admin/masters/citypincodes",
    home:"/admin/masters/home",
    service:"/admin/masters/services",
    audit:"/admin/masters/audit",
    corporatehospitalities:"/admin/masters/corporatehospitalities",
    brandvalues:"/admin/masters/brandvalues",
    Qualitypolicies:"/admin/masters/Qualitypolicies",
    whoweare:"/admin/masters/whoweare",


  },

aboutus:{
  aboutus: "admin/aboutus/aboutus",
  signatureskills:"admin/aboutus/signatureskills",
  visionandmissions:"admin/aboutus/visionandmissions",
  ourvictories:"admin/aboutus/ourvictories",
  ourachievement:"admin/aboutus/ourachievement",
 
},

services:{
  servicedescription: "admin/services/servicedescription",
  exceptionals: "admin/services/exceptional",
  highlights:"admin/services/highlights",
  philosophies:"admin/services/philosophy",
  excellences:"admin/services/excellence",
  testimonials:"admin/services/testimonial"
 
},
privacypolicy:{
 privacypolicy:"admin/privacypolicy/privacypolicies",
 
},
termscondition:{
 termscondition:"admin/termscondition/termsconditions",
 
},

contain:{
contactus:"admin/contactus/contactus",
appsetup:"/admin/appsetup/appsetups",
},


  // common
  Commons: {
    AllCountry: "/common/masters/all-country",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllCategory:"/common/masters/all-category",
    AllSubcategory:"common/masters/all-subcategory",
    AllHome: "/common/masters/all-home",
    AllServices: "/common/masters/all-services",
    AllAudit: "/common/masters/all-audit",
    AllCorporatehospitality:"/common/masters/all-corporatehospitalities",
    AllBrandvalue:"/common/masters/all-brandvalues",
    AllQualitypolicy:"/common/masters/all-qualitypolices",

    AllAboutUs:"/common/aboutus/all-aboutus",
    AllSignatureSkills:"/common/aboutus/all-signatureskill",
    AllVision:"/common/aboutus/all-visionandmission",
    AllOurVictory:"/common/aboutus/all-ourvictories",

    AllServiceDescription:"/common/services/all-servicedescription",
    AllExceptional:"/common/services/all-exceptional",
    AllHighlights:"/common/services/all-highlights",
    AllPhilosophy:"/common/services/all-philosophies",
    AllExcellence:"/common/services/all-excellences",
    AllTestimonial:"/common/services/all-testimonials",
   
    AllPrivacypolicy:"/common/privacypolicy/all-privacypolicies",
    AllTermscondition:"/common/termscondition/all-termsconditions",



  },

  // Dashboard
  Dashboard: {
    dashboard: "/admin/dashboard",
  },

};
